import React from "react";
import Slide from "react-reveal/Slide";
import { FaGithub, FaInstagram, FaSlack } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import "./contact.css";

class Contact extends React.Component {
  render() {
    return (
      <div className="footer">
        <ul className="icon-list">
          <li>
            <Slide left>
              <a href="https://github.com/krishnanand654">
                <FaGithub />
              </a>
            </Slide>
          </li>
          <li>
            <Slide left>
              <a href="https://www.instagram.com/a_n_a_n._d/">
                <FaInstagram />
              </a>
            </Slide>
          </li>
          <li>
            <Slide right>
              <a href="https://app.slack.com/client/TCYEB44S2/CCYHFT85B/user_profile/U03D281DCLU">
                <FaSlack />
              </a>
            </Slide>
          </li>
          <li>
            <Slide right>
              <a href="mailto:krishnanand654@gmail.com">
                <AiOutlineMail />
              </a>
            </Slide>
          </li>
        </ul>
        <p style={{ textAlign: "center" }}>
          <a href="https://www.buymeacoffee.com/akrishnanand">
            <img
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
              alt="Buy Me A Coffee"
              className="coffee"
            />
          </a>
        </p>
        <footer className="copyright">
          <p>
            copyright ©️ {new Date().getFullYear()} owned by{" "}
            <a href="https://github.com/krishnanand654">krishnanand</a>
          </p>
        </footer>
      </div>
    );
  }
}
export default Contact;
